import { PolicyAction } from "../actions/policy.actions";
import { initialState } from "../reducers/root.reducer";
import { PolicyActionTypes } from "../actions/types";
import { IPolicyResponse } from "../../models/policy-response.interface";

export const policyReducer = (
  state: IPolicyResponse | null = initialState.policyResponse,
  action: PolicyAction
) : IPolicyResponse | null  => {
  switch (action.type) {
    case PolicyActionTypes.CREATE_POLICY:
      return {...state, id: 0, products: [], failed: null };
    case PolicyActionTypes.CREATE_POLICY_COMPLETED:
      return action.payload;
    case PolicyActionTypes.CREATE_POLICY_FAILED:
      return {...state, id: 0, products: [], failed: new Date()};
    case PolicyActionTypes.CLEAR_POLICY_RESPONSE:
      return {...state, id: 0, products: [], failed: null }
    default:
      return state;
  }
};
